<template>
  <div class="center">
    <div class="square_titulo_vacio">
      <div class="square_titulo_valores_vacio" id="Div9" runat="server"></div>
    </div>

    <div class="q-pa-md row items-start">
      <q-card class="my-card">
        <q-card-section class="card_titulo">
          <div class="card_titulo_text">{{ text_titulo }}</div>
        </q-card-section>
        <q-card-actions v-show="!interno" align="around">
          <div class="flex-container">
            <div class="flex-item_5"></div>
            <div class="flex-item_30">{{ text_titulo_I }}</div>
            <div class="flex-item_60">
              <q-radio
                v-model="tipo_registro"
                dense
                val="Suez"
                label="Interno"
                color="primary"
              />&nbsp;&nbsp;&nbsp;&nbsp;
              <q-radio
                v-model="tipo_registro"
                dense
                val="Otra"
                label="Otra"
                color="primary"
              />
            </div>
          </div>
        </q-card-actions>
        <q-card-actions v-show="interno" align="around">
          <div class="flex-container">
            <div class="flex-item_60">
              <q-field borderless ref="UsuarioInternoModel.email">
                <q-input
                  v-model="UsuarioInternoModel.email"
                  required
                  maxlength="50"
                  dense
                  input-debounce="0"
                  class="col-12"
                  :error="$v.UsuarioInternoModel.email.$error"
                  :rules="[
                    (val) =>
                      validateEmail(val) || 'Correo electrónico no válido',
                  ]"
                  label="Introduce tu correo electrónico"
                ></q-input>
              </q-field>
            </div>
            <div class="flex-item_30"></div>
          </div>
        </q-card-actions>
        <q-card-actions align="right">
          <q-btn
            title="atrás"
            @click="atras"
            class="ma-2 buttonclaro"
            v-show="volver"
            >atrás</q-btn
          >
          <q-btn title="siguiente" @click="accion" class="ma-2 buttonoscuro">{{
            text_btn
          }}</q-btn>
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script>
import {
  QInput,
  QCard,
  QField,
  QCardSection,
  QCardActions,
  QRadio
} from 'quasar';
import { required } from 'vuelidate/lib/validators';

export default {
  mounted () {
    this.pintar_datos('Registrarse', 'Seleccione su empresa', 'siguiente');
    this.tipo_registro = 'Suez';
  },

  methods: {
    pintar_datos (titulo, tituloI, btn) {
      this.text_titulo = titulo;
      this.text_titulo_I = tituloI;
      this.text_btn = btn;
    },

    atras () {
      this.text_titulo = 'Registrarse';
      this.tipo_registro = 'Suez';
      this.text_titulo_I = 'Seleccione su empresa';
      this.text_btn = 'siguiente';
      this.volver = false;
      this.interno = false;
    },

    accion () {
      if (this.tipo_registro === 'Suez') {
        if (this.interno) {
          this.validar_usuario_interno();
        } else {
          this.pintar_datos('Registrarse como usuario Interno', '', 'enviar');
          this.interno = true;
          this.volver = true;
          this.UsuarioInternoModel = [];
          this.UsuarioInternoModel.$error = false;
        }
      } else {
        this.$router.push({ name: 'usuario_externo' });
      }
    },

    validateEmail (email_) {
      var re =
        // eslint-disable-next-line no-control-regex
        /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email_);
    },

    comprobar_datos_usuario_interno () {
      return this.validateEmail(this.UsuarioInternoModel.email);
    },

    validar_usuario_interno () {
      this.$v.UsuarioInternoModel.$touch();
      if (this.$v.UsuarioInternoModel.$error) {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      } else if (this.comprobar_datos_usuario_interno()) {
        this.Datos_user.mail = this.UsuarioInternoModel.email;
        this.Datos_user.isExternal = false;
        this.Datos_user.appName = 'TSZ';

        this.$store.commit('TSZ/setDatosUsuario', this.Datos_user);
        this.$store.commit('TSZ/setDatosProfile', this.Datos_profile);
        this.$store
          .dispatch('TSZ/postDatosValidarUsuario')
          .then((response) => {
            this.ok = true;
            this.$router.push({ name: 'login' });

            this.mostrar_mensajes(
              'Confirme su correo electrónico para completar el registro',
              'blue'
            );
          })

          .catch((err) => {
            this.ok = false;
            this.mostrar_mensajes(err.response.data, 'red');
          });
      } else {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      }
    },

    mostrar_mensajes (mensaje, color = 'red', timeout = 5000) {
      this.showError(mensaje, color, timeout);
    },

    showError (text, color, timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    }
  },

  validations: {
    UsuarioInternoModel: {
      email: { required }
    }
  },
  data () {
    return {
      text_titulo: '',
      tipo_registro: '',
      text_titulo_I: '',
      text_btn: '',
      volver: false,
      interno: false,
      UsuarioInternoModel: {},
      Datos_user: {
        mail: '',
        isExternal: null,
        appName: null,
        password: null,
        id: 0
      },
      Datos_profile: {
        nombre: null,
        apellidos: null,
        empresa: null,
        telefono: null,
        id: 0
      }
    };
  },

  components: {
    QInput,
    QCard,
    QField,
    QCardSection,
    QCardActions,
    QRadio
  }
};
</script>
<style lang="scss" scoped>
$azulHover: #225eac;
$azuloscuro: #002f6c;
$azuloclaro: #878b97;

.buttonoscuro {
  background-color: $azuloscuro !important;
  border: none;
  color: #fff;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $azulHover !important;
    color: #fff;
    font-weight: 600;
  }
}

.buttonclaro {
  border: 1px solid #002f6c;
  color: #002f6c;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $azuloscuro !important;
    color: #fff;
    font-weight: 600;
  }
}
</style>
